module.exports = __webpack_public_path__ + "img/teller.f6600a67.png";